// Minimal shims to satisfy legacy editors/renderers that extend ViewCell/DefaultEditor.
export abstract class ViewCell {
  value: any;
  rowData: any;
}

export abstract class DefaultEditor {
  cell: any;
  inputClass: string;
  disabled: boolean;
}
